const ARBITRUM_CHAINLINK_MAPPING = {
  // WETH / USD
  '0x639Fe6ab55C921f74e7fac1ee960C0B6293ba612': {
    from: '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // WBTC / USD
  '0x6ce185860a4963106506C203335A2910413708e9': {
    from: '0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 8,
    toDecimals: 8,
  },
  // LINK / USD
  '0x86E53CF1B870786351Da77A57575e79CB55812CB': {
    from: '0xf97f4df75117a78c1A5a0DBb814Af92458539FB4',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // USDC / USD
  '0x50834F3163758fcC1Df9973b6e91f0F0F0434aD3': {
    from: '0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 6,
    toDecimals: 8,
  },
  // USDT / USD
  '0x3f3f5dF88dC9F13eac63DF89EC16ef6e7E25DdE7': {
    from: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 6,
    toDecimals: 8,
  },
  // YFI / USD
  '0x745Ab5b69E01E2BE1104Ca84937Bb71f96f5fB21': {
    from: '0x82e3A8F066a6989666b031d916c43672085b1582',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // DAI / USD
  '0xc5C8E77B397E531B8EC06BFb0048328B30E9eCfB': {
    from: '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // MIM / USD
  '0x87121F6c9A9F6E90E59591E4Cf4804873f54A95b': {
    from: '0xFEa7a6a0B346362BF88A9e4A88416B77a57D6c2A',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // SPELL / USD
  '0x383b3624478124697BEF675F07cA37570b73992f': {
    from: '0x3E6648C5a70A150A88bCE65F4aD4d506Fe15d2AF',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
  // SUSHI / USD
  '0xb2A8BA74cbca38508BA1632761b56C897060147C': {
    from: '0xd4d42F0b6DEF4CE0383636770eF773390d85c61A',
    to: '0x0000000000000000000000000000000000000001',
    decimals: 8,
    fromDecimals: 18,
    toDecimals: 8,
  },
}

export default ARBITRUM_CHAINLINK_MAPPING
